import { faker } from '@faker-js/faker'
import { BillNote, GetBillNotesResponse } from '../types'

export const generateBillNotesResponse: (
    limit: number,
    totalItems: number
) => GetBillNotesResponse = (limit, totalItems) => {
    const items = Array.from(new Array(limit)).map(() => {
        const invoiceBill: BillNote = {
            billnoteId: faker.number.int(),
            note: faker.lorem.paragraph(),
            createdBy: faker.person.fullName(),
            createdAt: Math.floor(faker.date.past().getTime() / 1000),
            modifiedBy: faker.person.fullName(),
            modifiedAt: Math.floor(faker.date.recent().getTime() / 1000),
        }

        return invoiceBill
    })

    return {
        items,
        totalItems,
    }
}
